import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  dropdown: {},
  itemsWrapper: {
    padding: 4,
    display: "flex",
    width: "100%",
    boxSizing: "border-box"
  }
}));

export default useStyles;
//# sourceMappingURL=SelectPopover.styles.js.map
